module.exports = __webpack_public_path__ + "static/media/document_papers.c5d31796.svg";